import { axios } from "../core/axios.interceptor";

export function getOpenApiResponse(openApiRequest) {
    const response = axios.post(`/openApi/open-api-response`, openApiRequest);
    return response;
}

export function gptResponse(openApiRequest) {
    const response = axios.post(`/gpt`, openApiRequest);
    return response;
}

export function flattenData(openApiRequest) {
    const response = axios.post(`/gpt/flatten`, openApiRequest);
    return response;
}